var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('container',{staticStyle:{"padding-bottom":"0","height":"266px"},attrs:{"title":"成交溢价率分布","loading":_vm.loading,"nodata":_vm.nodata}},[_c('div',{staticStyle:{"height":"225px"},attrs:{"id":"premiumRateDistribution"}})])}
var staticRenderFns = []

export { render, staticRenderFns }